( function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('CountryCustomService', CountryCustomService);

    CountryCustomService.$inject = ['$http'];

    function CountryCustomService($http) {
        return {
            returnAllCountries: returnAllCountries,
            returnAllPortsByCountry: returnAllPortsByCountry,
            returnSearchCountries: returnSearchCountries
        };

        function returnSearchCountries(query) {
            var url = "api/_search/countries?query=" + query;
            return $http.get(url);
        }

        function returnAllCountries() {
            var url = "api/countries/all";
            return $http.get(url);
        }

        function returnAllPortsByCountry(countryId) {
            var url = "api/ports/country/" + countryId;
            return $http.get(url);
        }
    }
})();
